import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import Loading from './Loading';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend,
    Filler
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(LineElement, PointElement, LinearScale, CategoryScale, Tooltip, Legend, Filler, ChartDataLabels);

class DashboardMultiLineChart extends Component {
    render() {
        const { title = '', chartData = {}, icon = '', bg = 'primary', cardWrap = true, stacked = false, suggestedMaxY, suggestedMinY, datalabels } = this.props;
        const { labels = [], datasets = [] } = chartData;


        const maxValue = Math.max(
            ...datasets.flatMap(ds => ds.data || [])
        );

        const minValue = Math.min(
            ...datasets.flatMap(ds => ds.data || [])
        );

        const suggestedMax =
            Math.ceil((maxValue + suggestedMaxY) / 10) * 10;

        const suggestedMin =
            Math.ceil((minValue - suggestedMinY) / 10) * 10;

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    display: false,
                    position: 'right',
                    align: 'center',
                    labels: {
                        usePointStyle: true,
                        pointStyle: 'line',
                        boxWidth: 20,
                    }
                },
                tooltip: {
                    mode: 'index',
                    intersect: false,
                },
                datalabels: {
                    display: datalabels ? true : false,
                    align: 'top',
                    anchor: 'end',
                    offset: 4,
                    color: '#999',
                    formatter: (value) => value,
                    font: {
                        size: 10,
                        weight: 'bold'
                    }
                }
            },
            interaction: {
                mode: 'nearest',
                axis: 'x',
                intersect: false
            },
            scales: {
                x: {
                    stacked,
                    ticks: {
                        display: true
                    },
                    grid: {
                        display: false
                    },
                    title: {
                        display: false
                    }
                },
                y: {
                    stacked,
                    max: suggestedMaxY ? suggestedMax : null,
                    min: suggestedMinY ? suggestedMin : null,
                    ticks: {
                        display: true
                    },
                    grid: {
                        display: false
                    },
                    title: {
                        display: false
                    }
                }
            }
        };

        const chartContent = (
            <div style={{ height: '100%', minHeight: '300px' }}>
                {(labels.length > 0 && datasets.length > 0) ? (
                    <Line data={chartData} options={options} />
                ) : (
                    <Loading height="300px" variant="primary" />
                )}
            </div>
        )

        return (
            <>
                {cardWrap ? (<Card className="card-border mb-0">
                    <Card.Header className={`card-header-action bg-${bg}`}>
                        <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                    </Card.Header>
                    <Card.Body style={{ maxHeight: '350px', position: 'relative' }}>
                        {chartContent}
                    </Card.Body>
                </Card>) : chartContent
                }
            </>

        );
    }
}

export default DashboardMultiLineChart;
